import { render, staticRenderFns } from "./SearchResultTab.vue?vue&type=template&id=2892e23c&"
import script from "./SearchResultTab.vue?vue&type=script&lang=js&"
export * from "./SearchResultTab.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultTab.vue?vue&type=style&index=0&id=2892e23c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports